<form [formGroup]="form">
  <div
    *ngIf="form.get('isoCountry').value"
    class="iti-flag {{form.get('isoCountry').value}}"></div>
  <input
    type="text"
    class="p-y-1"
    ccInput
    [placeholder]="'MAPPING.DETECT_PREFIX_PLACEHOLDER' | translate"
    formControlName="pattern"
    (keyup)="onChangeInputValue($event)">
  <cc-input-errors
    [form]="form"
    inputName="pattern"
    [errors]="[{'required': 'ERRORS.REQUIRED'}, {'isoCountry': 'MAPPING.ERRORS.CORRECT_PREFIX'}]"></cc-input-errors>
</form>
